// TODO: Fix eslint errors.
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable promise/always-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable func-names */
/* eslint-disable no-plusplus */
/* eslint-disable camelcase */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable radix */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */

import React, { useState, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import dispatchRerender from 'dispatchRerender';
import redirect from 'redirect';
import ArticleListItem from '@Components/ArticleListItem';
import axios from 'axios';
import buildSearchListPager from 'buildSearchListPager';
import Logger from '@ffw/logger-lib';

const queryString = require('query-string');

function withSearch(ChildComponent) {
  return function (props) {
    const {
      intl, staticContext, match, pageType = 'workforce360',
    } = { ...props };
    const routeMatch = useRouteMatch();
    // Redirect to trailing slash.
    if (routeMatch.url.substr(-1) !== '/') {
      return redirect(`${routeMatch.url}/`);
    }

    const queryParams = props.location.search ? queryString.parse(props.location.search) : {};
    const searchParamsProps = props.match.params.searchParams || '';

    let initialData = {};
    if (staticContext && staticContext.data) {
      initialData = staticContext.data;
    } else if (window.__ROUTE_DATA__) {
      initialData = window.__ROUTE_DATA__;
    }

    const [state, setState] = useState(initialData);
    const [cookies] = useCookies(['sortBy']);

    useEffect(() => {
      if (window.__ROUTE_DATA__) {
        setState(window.__ROUTE_DATA__);
        delete window.__ROUTE_DATA__;
      } else {
        const callbackAlias = '@Callbacks/getSearchResultsAndAggregations';
        const data = {
          cookies: cookies && cookies.sortBy ? { sortBy: cookies.sortBy } : {},
        };
        axios.get(`/api/articles/get-callback/?callback=${callbackAlias}&searchParams=${encodeURIComponent(JSON.stringify(searchParamsProps))}&pageType=${pageType}&queryParams=${encodeURIComponent(JSON.stringify(queryParams))}&data=${JSON.stringify(data)}&language=${intl.locale}`).then((response) => {
          setState(response.data);
          dispatchRerender();
        }).catch((error) => {
          Logger.error(error, 'components/hoc/Search');
        });
      }
    }, [searchParamsProps, props.location.search, cookies.sortBy]);

    const articles = [];
    let total = 0;
    let noResults = true;
    const searchParams = state.searchParams || {};
    const canonicalOverrides = state.canonicalOverridesResponse || null;
    let pager = {};
    if (state.searchResults && state.searchResults.hits && state.searchResults.hits.hits.length > 0) {
      noResults = false;
      total = state.searchResults.hits.total;
      const ITEMS_PER_PAGE = parseInt(process.env.REACT_APP_SEARCH_ITEMS_PER_PAGE);

      // Set counter to remove divider line from the last element on page.
      let article_number = 1;
      for (const id in state.searchResults.hits.hits) {
        const articleData = state.searchResults.hits.hits[id]._source;
        articles.push(<ArticleListItem key={id} articleData={articleData} divider={state.searchResults.hits.hits.length !== article_number} />);
        article_number++;
      }
    }

    if (!noResults) {
      pager = buildSearchListPager(pageType, searchParams, total, match.path.replace(':searchParams*', ''));
    }
    return <ChildComponent intl={intl} searchParams={searchParams} pager={pager} articles={articles} total={total} canonicalOverrides={canonicalOverrides} {...props} />;
  };
}

export default withSearch;
